import { FC } from "react";
import { IconPropsType } from ".";

export const BasicData: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 15H3C2.44772 15 2 15.4477 2 16V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V16C22 15.4477 21.5523 15 21 15ZM3 14C1.89543 14 1 14.8954 1 16V21C1 22.1046 1.89543 23 3 23H21C22.1046 23 23 22.1046 23 21V16C23 14.8954 22.1046 14 21 14H3Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 4H3C2.44772 4 2 4.44772 2 5V10C2 10.5523 2.44772 11 3 11H21C21.5523 11 22 10.5523 22 10V5C22 4.44771 21.5523 4 21 4ZM3 3C1.89543 3 1 3.89543 1 5V10C1 11.1046 1.89543 12 3 12H21C22.1046 12 23 11.1046 23 10V5C23 3.89543 22.1046 3 21 3H3Z"
        fill={props.color}
      />
    </svg>
  );
};
